import { useState } from 'react';

const MIN = 15;
const MAX = 22;
const DEFAULT = 16;

/**
 * A− / A+ font-size control. Tailwind sizes are rem-based, so scaling the root
 * html font-size scales the whole UI proportionally. Fixed, bottom-right.
 */
export default function FontSize(): JSX.Element {
  const [px, setPx] = useState(DEFAULT);

  function apply(next: number): void {
    const clamped = Math.max(MIN, Math.min(MAX, next));
    setPx(clamped);
    document.documentElement.style.fontSize = `${clamped}px`;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-1 bg-warm-dark-2 border border-warm-dark-2 rounded-full px-2 py-1 shadow-lg">
      <button
        onClick={() => apply(px - 1)}
        disabled={px <= MIN}
        aria-label="Decrease text size"
        className="w-7 h-7 rounded-full text-text-secondary hover:text-cyan disabled:opacity-40 font-mono text-sm"
      >
        A−
      </button>
      <span className="font-mono text-sm text-text-secondary w-8 text-center">{px}px</span>
      <button
        onClick={() => apply(px + 1)}
        disabled={px >= MAX}
        aria-label="Increase text size"
        className="w-7 h-7 rounded-full text-text-secondary hover:text-cyan disabled:opacity-40 font-mono text-base"
      >
        A+
      </button>
    </div>
  );
}
